import antiNauseaInitialQuestions, {
  AntiNauseaQuestionFieldAnswers
} from './initial/questions';
import antiNauseaFollowupQuestions, {
  AntiNauseaFollowupQuestionFieldAnswers
} from './followup/questions';

const AntiNauseaQuestions = [
  ...antiNauseaInitialQuestions,
  ...antiNauseaFollowupQuestions
];
export default AntiNauseaQuestions;

export type { AntiNauseaQuestionFieldAnswers, AntiNauseaFollowupQuestionFieldAnswers };
